import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 연관사이트 제어 컴포넌트
 */
const RelatedSitesControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};

  const relatedSitesEnabled = currentThemeConfig.relatedSitesEnabled !== false;
  const relatedSitesType = currentThemeConfig.relatedSitesType || 'image-thumbnail';
  const relatedSitesShowTitle = currentThemeConfig.relatedSitesShowTitle !== false;
  const relatedSitesShowImage = currentThemeConfig.relatedSitesShowImage !== false;
  const relatedSitesShowUrl = currentThemeConfig.relatedSitesShowUrl === true;

  return (
    <div id="related-sites-control-section" style={{ marginBottom: '20px' }}>
      {/* 연관사이트 영역 on/off */}
      <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>연관사이트 영역 표시:</label>
          <label
            style={{
              position: 'relative',
              display: 'inline-block',
              width: '50px',
              height: '24px',
              cursor: 'pointer'
            }}
          >
            <input
              type="checkbox"
              checked={relatedSitesEnabled}
              onChange={(e) => {
                set('relatedSitesEnabled', e.target.checked);
              }}
              style={{
                opacity: 0,
                width: 0,
                height: 0
              }}
            />
            <span
              style={{
                position: 'absolute',
                cursor: 'pointer',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: relatedSitesEnabled ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
                transition: '0.3s',
                borderRadius: '24px'
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  height: '18px',
                  width: '18px',
                  left: '3px',
                  bottom: '3px',
                  backgroundColor: 'white',
                  transition: '0.3s',
                  borderRadius: '50%',
                  transform: relatedSitesEnabled ? 'translateX(26px)' : 'translateX(0)'
                }}
              />
            </span>
          </label>
        </div>
        <div style={{ fontSize: '11px', color: '#666' }}>
          {relatedSitesEnabled ? '표시됨' : '숨김'} - 연관사이트 영역 전체를 표시하거나 숨깁니다
        </div>
      </div>

      {/* 스위치가 OFF이면 아래 테마 제어 항목은 숨김 */}
      {relatedSitesEnabled && (
        <>
      {/* 연관사이트 유형 선택 */}
      <div style={{ marginBottom: '15px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>🔗 연관사이트 유형:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="related-sites-control-section"
            title="이 항목으로 이동"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = 'var(--theme-color-primary)';
              e.target.style.color = 'var(--theme-color-primary)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#ddd';
              e.target.style.color = '#666';
            }}
          >
            ?
          </button>
        </div>
        <CustomSelect
          value={relatedSitesType}
          onChange={(v) => set('relatedSitesType', v)}
          isSearchable={false}
          isClearable={false}
          options={[
            { value: 'image-thumbnail', label: '이미지썸네일 유형' },
            { value: 'combo', label: '기본콤보형' },
            { value: 'list', label: '리스트형' },
          ]}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              minHeight: 34,
              fontSize: 12,
              borderRadius: 4,
              borderColor: state.isFocused ? '#86b7fe' : '#ddd',
            }),
            valueContainer: (base) => ({ ...base, padding: '0 10px' }),
            indicatorsContainer: (base) => ({ ...base, height: 34 }),
          }}
        />
      </div>

      {/* 이미지썸네일 유형 옵션 */}
      {relatedSitesType === 'image-thumbnail' && (
        <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
            <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>하단 사이트 제목:</label>
            <label
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '50px',
                height: '24px',
                cursor: 'pointer'
              }}
            >
              <input
                type="checkbox"
                checked={relatedSitesShowTitle}
                onChange={(e) => {
                  set('relatedSitesShowTitle', e.target.checked);
                }}
                style={{
                  opacity: 0,
                  width: 0,
                  height: 0
                }}
              />
              <span
                style={{
                  position: 'absolute',
                  cursor: 'pointer',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: relatedSitesShowTitle ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
                  transition: '0.3s',
                  borderRadius: '24px'
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    height: '18px',
                    width: '18px',
                    left: '3px',
                    bottom: '3px',
                    backgroundColor: 'white',
                    transition: '0.3s',
                    borderRadius: '50%',
                    transform: relatedSitesShowTitle ? 'translateX(26px)' : 'translateX(0)'
                  }}
                />
              </span>
            </label>
          </div>
          <div style={{ fontSize: '11px', color: '#666' }}>
            {relatedSitesShowTitle ? '표시됨' : '숨김'} - 제목을 숨기면 높이가 축소됩니다
          </div>
        </div>
      )}

      {/* 기본콤보형 옵션 */}
      {relatedSitesType === 'combo' && (
        <div style={{ padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
          <div style={{ fontSize: '11px', color: '#666' }}>
            기본콤보형은 셀렉트 박스만 표시됩니다
          </div>
        </div>
      )}

      {/* 리스트형 옵션 */}
      {relatedSitesType === 'list' && (
        <div style={{ padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>이미지 표시:</label>
              <label
                style={{
                  position: 'relative',
                  display: 'inline-block',
                  width: '50px',
                  height: '24px',
                  cursor: 'pointer'
                }}
              >
                <input
                  type="checkbox"
                  checked={relatedSitesShowImage}
                  onChange={(e) => {
                    set('relatedSitesShowImage', e.target.checked);
                  }}
                  style={{
                    opacity: 0,
                    width: 0,
                    height: 0
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: relatedSitesShowImage ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
                    transition: '0.3s',
                    borderRadius: '24px'
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      height: '18px',
                      width: '18px',
                      left: '3px',
                      bottom: '3px',
                      backgroundColor: 'white',
                      transition: '0.3s',
                      borderRadius: '50%',
                      transform: relatedSitesShowImage ? 'translateX(26px)' : 'translateX(0)'
                    }}
                  />
                </span>
              </label>
            </div>
          </div>
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>URL 주소 표시:</label>
              <label
                style={{
                  position: 'relative',
                  display: 'inline-block',
                  width: '50px',
                  height: '24px',
                  cursor: 'pointer'
                }}
              >
                <input
                  type="checkbox"
                  checked={relatedSitesShowUrl}
                  onChange={(e) => {
                    set('relatedSitesShowUrl', e.target.checked);
                  }}
                  style={{
                    opacity: 0,
                    width: 0,
                    height: 0
                  }}
                />
                <span
                  style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: relatedSitesShowUrl ? (currentThemeConfig.themeColor || '#e97730') : '#ccc',
                    transition: '0.3s',
                    borderRadius: '24px'
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      height: '18px',
                      width: '18px',
                      left: '3px',
                      bottom: '3px',
                      backgroundColor: 'white',
                      transition: '0.3s',
                      borderRadius: '50%',
                      transform: relatedSitesShowUrl ? 'translateX(26px)' : 'translateX(0)'
                    }}
                  />
                </span>
              </label>
            </div>
          </div>
          <div style={{ fontSize: '11px', color: '#666' }}>
            리스트형은 제목 우측 토글 화살표로 리스트를 접었다 펼칠 수 있습니다
          </div>
        </div>
      )}
        </>
      )}
    </div>
  );
};

export default RelatedSitesControl;
